<template>
  <div class="container">
    <div class="form_container">
      <p class="form_subtitle">Contact</p>
      <p class="form_title">Boost your practice<br />with DENTRON!</p>

      <form class="form" @submit.prevent="handleSubmit">
        <div class="input_group">
          <div class="field_wrapper">
            <label class="field_label">First Name</label>
            <input
              type="text"
              class="input_field"
              v-model.trim="form.firstName"
            />
          </div>
          <div class="field_wrapper">
            <label class="field_label">Last Name</label>
            <input
              type="text"
              class="input_field"
              v-model.trim="form.lastName"
            />
          </div>
        </div>

        <div class="field_wrapper">
          <label class="field_label">Email Address</label>
          <div class="email_input_group">
            <input type="text" class="input_field" v-model.trim="emailLocal" />
            <span class="at_symbol">@</span>
            <input type="text" class="input_field" v-model.trim="emailDomain" />
          </div>
          <p v-if="emailDomain && !isEmailDomainValid" class="error_message">
            Invalid email format.
          </p>
        </div>

        <div class="field_wrapper">
          <label class="field_label">Name of Practice</label>
          <input
            type="text"
            class="input_field"
            v-model.trim="form.practiceName"
          />
        </div>

        <div class="field_wrapper">
          <label class="field_label">Select a Country</label>
          <select
            class="select_field"
            v-model="form.country"
            :class="{ 'is-placeholder': form.country === '' }"
          >
            <option value="" selected>Select a Country</option>
            <option
              v-for="country in countries"
              :key="country"
              :value="country"
            >
              {{ country }}
            </option>
          </select>
        </div>

        <div class="field_wrapper">
          <label class="field_label">Select Intraoral Scanner</label>
          <select
            class="select_field"
            v-model="form.scanner"
            :class="{ 'is-placeholder': form.scanner === '' }"
          >
            <option value="" selected>Select Intraoral Scanner</option>
            <option v-for="scanner in scanners" :key="scanner" :value="scanner">
              {{ scanner }}
            </option>
          </select>
        </div>

        <div class="field_wrapper">
          <label class="field_label">Message</label>
          <textarea
            class="textarea_field"
            v-model.trim="form.message"
          ></textarea>
        </div>

        <div
          class="checkbox_wrapper"
          @click="form.privacyAgreement = !form.privacyAgreement"
        >
          <img
            v-if="form.privacyAgreement"
            src="@/assets/icon/icon_check.svg"
            alt="Checked"
            class="checkbox_icon"
          />
          <img
            v-else
            src="@/assets/icon/icon_uncheck.svg"
            alt="Unchecked"
            class="checkbox_icon"
          />
          <span class="checkbox_label">
            I agree to the collection and use of my personal data in accordance with
            the Privacy Policy.
          </span>
        </div>

        <button type="submit" class="submit_button" :disabled="!isFormComplete">
          Send
        </button>
      </form>
      <SendSuccess v-if="showSuccessModal" @close="closeModal" />
    </div>
  </div>
</template>

<script>
import data from "@/assets/data/data.json";
import SendSuccess from "./send_success.vue";
import emailjs from "@emailjs/browser";

export default {
  components: {
    SendSuccess,
  },
  data() {
    return {
      countries: data.countries,
      scanners: data.scanners,
      emailLocal: "",
      emailDomain: "",
      form: {
        firstName: "",
        lastName: "",
        // email: "", // email은 조립해서 전송하므로 여기서 관리하지 않음
        practiceName: "",
        country: "",
        scanner: "",
        message: "",
        privacyAgreement: false,
      },
      showSuccessModal: false,
    };
  },
  computed: {
    isEmailDomainValid() {
      // 표준 도메인 정규식: 영문/숫자/하이픈 + 점(.) + 2글자 이상의 TLD
      // 예: example.com, co.kr
      const domainRegex = /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
      return domainRegex.test(this.emailDomain);
    },
    isFormComplete() {
      return (
        this.form.firstName &&
        this.form.lastName &&
        this.emailLocal &&
        this.emailDomain &&
        this.isEmailDomainValid && // 이메일 도메인 유효성 검사 추가
        this.form.practiceName &&
        this.form.country &&
        this.form.scanner &&
        this.form.message &&
        this.form.privacyAgreement
      );
    },
  },
  methods: {
    handleSubmit() {
      if (!this.isFormComplete) return;

      // 이메일 조립
      const fullEmail = `${this.emailLocal}@${this.emailDomain}`;

      const templateParams = {
        name: `${this.form.firstName} ${this.form.lastName}`,
        country: this.form.country,
        email: fullEmail,
        practice: this.form.practiceName,
        scanner: this.form.scanner,
        message: this.form.message,
      };

      const SERVICE_ID = "DentrionEN";
      const TEMPLATE_ID = "EN_Contact_temp";
      const PUBLIC_KEY = process.env.VUE_APP_EMAILJS_KEY;

      console.log("EmailJS Params:", { SERVICE_ID, TEMPLATE_ID, PUBLIC_KEY }); // Debugging Log

      emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY).then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          this.showSuccessModal = true;
          this.resetForm();
        },
        (error) => {
          console.log("FAILED...", error);
          alert("Failed to send email. Please try again.");
        }
      );
    },
    resetForm() {
      this.emailLocal = "";
      this.emailDomain = "";
      this.form = {
        firstName: "",
        lastName: "",
        // email: "",
        practiceName: "",
        country: "",
        scanner: "",
        message: "",
        privacyAgreement: false,
      };
    },
    closeModal() {
      this.showSuccessModal = false;
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  padding: 60px 15px;
  height: 100%;
  box-sizing: border-box;
}

.form_container {
  background-color: white;
  border-radius: 16px; 
  box-sizing: border-box;
  padding: 32px 16px;
  width: calc(100% - 20px);
  margin: 0 auto;
}

.form_subtitle {
  font-size: 16px;
  font-weight: 500;
  color: #121212;
  letter-spacing: -0.8px;
  font-family: "Wanted Sans", -apple-system, BlinkMacSystemFont, system-ui,
    Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR",
    "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
  text-align: center;
}

.form_title {
  font-size: 24px;
  font-weight: 900;
  text-align: center;
  font-family: "Wanted Sans", -apple-system, BlinkMacSystemFont, system-ui,
    Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR",
    "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
  margin-top: 8px;
  margin-bottom: 32px;
  color: black;
  letter-spacing: -1.2px;
  line-height: 128%;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.field_wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field_label {
  color: #0B485B;
  font-family: "Wanted Sans", -apple-system, BlinkMacSystemFont, system-ui,
    Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR",
    "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 128%;
  letter-spacing: -0.8px;
}

.input_group {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.input_group > .field_wrapper {
  flex: 1;
}

.email_input_group .input_field:first-of-type {
  flex: 4;
}

.email_input_group .input_field:last-of-type {
  flex: 6;
}

.email_input_group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.at_symbol {
  font-size: 16px;
  font-weight: 500;
  color: #3a3a3a;
}

.error_message {
  color: #ff0000;
  font-size: 14px;
  margin-top: 4px;
}

.input_field,
.select_field,
.textarea_field {
  width: 100%;
  box-sizing: border-box;
  background-color: white; 
  border: 1px solid rgba(17, 17, 19, 0.2);
  padding: 14px;
  border-radius: 4px;
  font-size: 16px;
  color: #3a3a3a;
  opacity: 1; /* iOS fix */
  -webkit-text-fill-color: #3a3a3a; /* iOS fix */
}

.select_field.is-placeholder {
  color: #7c7c7c;
  -webkit-text-fill-color: #7c7c7c;
}

::placeholder {
  color: #7c7c7c;
  opacity: 1;
  -webkit-text-fill-color: #7c7c7c;
}

.input_field:focus,
.select_field:focus,
.textarea_field:focus {
  outline: none;
  border-color: black;
}

.textarea_field {
  height: 144px;
  resize: none;
}

.select_field {
  appearance: none;
  background-image: url("data:image/svg+xml;utf8,<svg fill='gray' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-repeat: no-repeat;
  background-position: right 0.7rem center;
  background-size: 30px;
}

.checkbox_wrapper {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  cursor: pointer;
}

.checkbox_icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.checkbox_label {
  color: #3a3a3a;
  font-family: "Wanted Sans", -apple-system, BlinkMacSystemFont, system-ui,
    Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR",
    "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 128%; /* 17.92px */
  letter-spacing: -0.7px;
}

.submit_button {
  background-color: #51C37E;
  color: white;
  font-weight: 700;
  padding: 13px 0;
  border-radius: 4px;
  width: 100%; 
  font-family: "Wanted Sans", -apple-system, BlinkMacSystemFont, system-ui,
    Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR",
    "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
    sans-serif;
  border: none;
  margin-top: 16px;
  font-size: 16px;
  cursor: pointer;
  box-shadow: 4px 4px 4px 0 rgba(0, 0, 0, 0.10);
  transition: background-color 0.3s ease;
}

.submit_button:disabled {
  background-color: #CFCFD0;
  cursor: not-allowed;
  opacity: 0.7;
}
</style>
